import React, { useEffect } from 'react';
import { Notifications, Taxes, Import_, Reset, Broker, TwoFactor } from './components';
import { connect } from 'react-redux';
import * as actions from 'redux/actions/settingActions';
import { Translate } from 'react-redux-i18n';
import 'assets/css/settings.css';

const Settings = (props) => {
  useEffect(() => {
    props.loadItem(props.user_id, props.token);
  }, [props.user_id, props.token, props.loadItem]);

  return (
    <div className="settings-page">
      <header className="settings-page-header">
        <h1 className="settings-page-title">
          <Translate value="setting" />
        </h1>
        <p className="settings-page-subtitle">
          <Translate value="manage_notifications" />
        </p>
      </header>

      <div className="settings-grid">
        <Notifications />
        <TwoFactor />
      </div>

      <div className="settings-grid">
        <Taxes />
        <Reset />
      </div>

      <div className="settings-grid settings-grid--stack">
        <Broker />
      </div>

      <div className="settings-grid settings-grid--stack">
        <div className="settings-panel">
          <Import_ />
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,
    setting: reducer.setting.item,
  };
}

const mapDispatchToProps = (dispatch) => ({
  loadItem: (user_id, token) =>
    dispatch(actions.loadItem({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
